import * as React from "react";
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m16.914 9-6.707 6.707-1.414-1.414L13.086 10H1.5V8h11.586L8.793 3.707l1.414-1.414L16.914 9Z" }));
export default SvgArrowRight;
